module.exports = __webpack_public_path__ + "static/media/logo_go.5b448728.png";